import { HttpHeaders } from "types/generic";

import { LOGS_PREFIX } from "core/config";
import ApiError from "./ApiError";
import createPromise from "helpers/createPromise";

function fetchWrapper(
  url: string,
  config: RequestInit = {}
): Promise<[Response, HttpHeaders]> {
  return createPromise<[Response, HttpHeaders]>((resolve, reject) => {
    const abort = (msg: string | number, body: object = {}) => {
      reject(
        new ApiError(`${LOGS_PREFIX} Request to ${url} failed: ${msg}`, body)
      );
    };

    fetch(url, config).then(
      (res) => {
        if (!res.ok) {
          if (res.status) {
            if (res.status === 422) {
              res
                .json()
                .then((body) => {
                  abort(res.status, body);
                })
                .catch(() => abort(res.status));
              return;
            }

            abort(res.status);
            return;
          }

          abort("");
          return;
        }

        const headers: HttpHeaders = {};
        res.headers.forEach((value, key) => {
          headers[key.toLowerCase()] = value;
        });

        resolve([res, headers]);
      },
      (e) => {
        abort(e.message);
      }
    );
  });
}

export default fetchWrapper;
